import { MutableRefObject } from 'react';
import { ID } from 'types';
import { isCustomColumn, getHeaderID } from './utils';

export type MenuOption = 'add_custom_column' | 'divider' | 'edit_custom_column' | 'remove_custom_column';

interface CanViewOptionsParams {
  headerMap: ID[];
  hotRef: MutableRefObject<any>;
  menuOption?: MenuOption;
}

// Hide menu options if header is not a custom_column
// id | name | units | price | extended_quantity | baseline_price | is_required
export const hideMenuOptions = ({
  headerMap,
  hotRef,
  menuOption,
}: CanViewOptionsParams): boolean => {
  const header = getHeaderID({ headerMap, hotRef });
  if (!header) return false;

  if (header === 'name' && menuOption === 'add_custom_column') return true;

  // Currently, we only want to display the dropdown options for custom columns
  // In the future, we may want to return true for other types of columns
  return isCustomColumn(header);
};
